import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  ComplianceAwardIcon,
  LeasingAwardIcon,
  MaintenanceAwardIcon,
  NewHireAwardIcon,
  SafetyAwardIcon,
  SupervisorAwardIcon,
  GuestAdvocateAwardIcon,
  DefaultAwardIcon
} from "./AwardTypeIcons";

const awardTypes = {
  default: "default",
  compliance: "compliance",
  leasing: "leasing",
  maintenance: "maintenance",
  newHire: "newhire",
  safety: "safety",
  supervisor: "supervisor",
  guestAdvocate: "guestadvocate"
};

const useStyles = makeStyles(theme => ({
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  button: {
    padding: 0,
    marginBottom: theme.spacing(2)
  }
}));

const GenericAwardIcon = ({ icon, awardType, ...awardIconProps }) => {
  switch (icon || awardType) {
    case awardTypes.compliance:
      return <ComplianceAwardIcon {...awardIconProps} />;
    case awardTypes.leasing:
      return <LeasingAwardIcon {...awardIconProps} />;
    case awardTypes.maintenance:
      return <MaintenanceAwardIcon {...awardIconProps} />;
    case awardTypes.newHire:
      return <NewHireAwardIcon {...awardIconProps} />;
    case awardTypes.safety:
      return <SafetyAwardIcon {...awardIconProps} />;
    case awardTypes.supervisor:
      return <SupervisorAwardIcon {...awardIconProps} />;
    case awardTypes.guestAdvocate:
      return <GuestAdvocateAwardIcon {...awardIconProps} />;
    case awardTypes.default:
    default:
      return <DefaultAwardIcon {...awardIconProps} />;
  }
};

const getAwardBackgroundColor = (hasBackground, awardColor) => {
  if (!hasBackground || awardColor === "#000000") {
    return "rgba(0, 0, 0, 0)";
  } else {
    return alpha(`${awardColor}`, 0.1);
  }
};

const AwardIcon = ({
  customIcon,
  awardType,
  awardColor,
  awardTitle,
  hasBackground,
  iconSize,
  icon,
  height,
  width
}) => {
  const classes = useStyles();
  return (
    <Box
      height={height}
      width={width}
      className={classes.icon}
      bgcolor={getAwardBackgroundColor(hasBackground, awardColor)}
    >
      {customIcon ? (
        <img
          src={customIcon}
          alt={awardTitle}
          width="100%"
          height="100%"
          style={{ objectFit: "cover" }}
        />
      ) : (
        <GenericAwardIcon
          icon={icon}
          boxShadow={false}
          fill={awardColor}
          awardType={awardType}
          width={iconSize}
          height={iconSize}
        />
      )}
    </Box>
  );
};
AwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  awardColor: PropTypes.string,
  awardType: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

AwardIcon.defaultProps = {
  awardType: "default",
  awardColor: "#000000",
  hasBackground: true,
  height: 128,
  width: 128,
  iconSize: "64%"
};

export default AwardIcon;
